import { CardLimitType } from "./types";

const mapPageModelToRequest = (
  spendingLimit: number,
  spendingLimitOther: string,
): number => {
  return spendingLimit === CardLimitType.LIMIT_OTHER
    ? parseInt(spendingLimitOther.replace(" ", ""), 10)
    : spendingLimit;
};

interface CardLimitModel {
  spendingLimit: number;
  spendingLimitOther: string;
}

const mapDocumentToPageModel = (limit: number): CardLimitModel => {
  return {
    spendingLimit: limit in CardLimitType ? limit : CardLimitType.LIMIT_OTHER,
    spendingLimitOther: limit in CardLimitType ? null : `${limit}`,
  };
};

const CardLimitMapper = {
  mapPageModelToRequest,
  mapDocumentToPageModel,
};

export default CardLimitMapper;
